/**
 * 图片验证码
 */
export class ImageVerificationCode {
  /**
   * 验证码票据
   */
  ticket: string
  /**
   * 图片base64数据
   */
  base64Data: string
}
